import { render, staticRenderFns } from "./IssueEscalationGroups.vue?vue&type=template&id=46a298d2"
import script from "./IssueEscalationGroups.vue?vue&type=script&lang=ts"
export * from "./IssueEscalationGroups.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports